import axios from 'axios';
import { clearAuthStorage } from 'utils/authStorage';

const axiosInstance = axios.create({ baseURL: '/api/' });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Access token süresi dolmuş/geçersiz — token yenileme bu fazda yok,
    // oturumu temizleyip login'e dön (aksi halde uygulama sessizce kırık kalır).
    if (error.response && error.response.status === 401 && window.location.pathname !== '/login') {
      clearAuthStorage();
      window.location.href = '/login';
    }
    return Promise.reject((error.response && error.response.data) || 'Sunucuya ulaşılamadı.');
  }
);

export function setAuthToken(token) {
  if (token) {
    axiosInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete axiosInstance.defaults.headers.common.Authorization;
  }
}

export default axiosInstance;
